// Use this tag to get css syntax highlighting and linting
export const css = String.raw
